import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type IndividualCourseAssignmentCompletion = {
   totalCompletion: number;
};

export async function getCourseAssignmentCompletion(
   userid: number,
   common: CommonRequestOptions = {}
): Promise<IndividualCourseAssignmentCompletion> {
   return makeRequest('get', `/course_assignments/completion/user/${userid}`, common);
}

type CourseAssignmentUserCompletionErrorCode =
   'course_assignments.get_user_completion.user_not_found';

getCourseAssignmentCompletion.errorMessages =
   createErrorMessageTypeGuard<CourseAssignmentUserCompletionErrorCode>();
